import { render, staticRenderFns } from "./ImpactOfDisability.vue?vue&type=template&id=0a231d9f&scoped=true"
import script from "./ImpactOfDisability.vue?vue&type=script&lang=js"
export * from "./ImpactOfDisability.vue?vue&type=script&lang=js"
import style0 from "./ImpactOfDisability.vue?vue&type=style&index=0&id=0a231d9f&prod&scoped=true&lang=less"
import style1 from "./ImpactOfDisability.vue?vue&type=style&index=1&id=0a231d9f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a231d9f",
  null
  
)

export default component.exports